// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"374c1861","732":"af9a4b5e","977":"243bacf6"}[chunkId] + ".chunk.js";
};